import Vue from 'vue'
import App from './App.vue'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@fortawesome/fontawesome-free/css/all.css'
import vuetify from './plugins/vuetify'
import VueRouter from 'vue-router'
import router from './Router/router'
import VueMeta from 'vue-meta'
import store from './store/index.js'
import axios from 'axios'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import { getDetailedError } from "./helpers"
import PaceProgress from 'pace-progress'
import ls from './settings/localStorageExtension'
import EventBus from './event-bus'
import 'animate.css';
// import {Synchronize} from'./syncing/synchronizer.js'
Vue.config.productionTip = false
// name is optional
Vue.use(VueLodash, { lodash: lodash })
window._ = lodash

Vue.use(vuetify)
Vue.use(VueRouter)
Vue.use(VueMeta, {keyName: 'meta',});
// features-components
import splashWindow  from "./components/features/SplashWindow.vue"

// custom-components
import BeeAutocomplete  from "./components/custom-components/toolkits/editable/BeeAutocomplete"
import BeeAccountAutocomplete  from "./components/custom-components/mirta-based/BeeAccountAutocomplete"
import BeeAccountLabel from './components/custom-components/mirta-based/BeeAccountLabel.vue'
import BeeAccountingNoField  from "./components/custom-components/mirta-based/BeeAccountingNoField.vue"
import BeeAdvancedMoneyLabel from "./components/custom-components/mirta-based/BeeAdvancedMoneyLabel"
import BeeBtn  from "./components/custom-components/toolkits/readonly/BeeBtn.vue"
import BeeBreadcrumbs from './components/custom-components/toolkits/readonly/BeeBreadcrumbs.vue'
import BeeBondUpDown from './components/features/journals/sub-components/BeeBondUpDown.vue'
import BeeHintMenu from './components/custom-components/toolkits/readonly/BeeHintMenu.vue'
import BeeProgressCircular from './components/custom-components/toolkits/readonly/BeeProgressCircular.vue'
import BeeProgressLinear from './components/custom-components/toolkits/readonly/BeeProgressLinear.vue'
import BeeCheckbox  from "./components/custom-components/toolkits/editable/BeeCheckbox.vue"
import BeeCurrenciesAutocomplete  from "./components/custom-components/mirta-based/BeeCurrenciesAutocomplete.vue"
import BeeCombobox from './components/custom-components/toolkits/editable/BeeCombobox'
import BeeConfirmDialog from './components/custom-components/toolkits/readonly/BeeConfirmDialog.vue'
import BeeDateField  from "./components/custom-components/toolkits/editable/BeeDateField.vue"
import BeeDatePicker  from "./components/custom-components/toolkits/editable/BeeDatePicker.vue"
import BeeDatatable from './components/custom-components/toolkits/datatables/BeeDatatable.vue'
import BeeDataIterator from './components/custom-components/toolkits/datatables/bee-data-iterator/BeeDataIterator.vue'
import BeeDialog  from "./components/custom-components/toolkits/readonly/BeeDialog.vue"
import BeeDateLabel from './components/custom-components/toolkits/readonly/BeeDateLabel.vue'
import BeeSmartTable from './components/custom-components/mirta-based/BeeSmartTable.vue'
import BeeLabel from './components/custom-components/toolkits/readonly/BeeLabel.vue'
import BeeList from './components/custom-components/toolkits/readonly/BeeList'
import BeeListItem from './components/custom-components/toolkits/readonly/BeeListItem'
import BeeListGroup from './components/custom-components/toolkits/readonly/BeeListGroup'
import BeeMultiSelect  from "./components/custom-components/toolkits/editable/BeeMultiSelect.vue"
import BeeMoneyLabel from './components/custom-components/mirta-based/BeeMoneyLabel.vue'
import BeeMoneyField  from "./components/custom-components/mirta-based/BeeMoneyField.vue"
import BeeNumericField  from "./components/custom-components/toolkits/editable/BeeNumericField.vue"
import BeeOutlinedHeaderInfo from './components/custom-components/toolkits/readonly/BeeOutlinedHeaderInfo.vue'
import BeeQuantityLabel from './components/custom-components/mirta-based/BeeQuantityLabel.vue'
import BeeSnackbar from "./components/custom-components/toolkits/readonly/BeeSnackbar.vue";
import BeeSimpleTable from './components/custom-components/toolkits/datatables/BeeSimpleTable.vue'
import BeeTableRow from './components/custom-components/toolkits/datatables/bee-data-iterator/BeeTableRow.vue'
import BeeTableHeader from './components/custom-components/toolkits/datatables/bee-data-iterator/BeeTableHeader.vue'
import BeeTextField from './components/custom-components/toolkits/editable/BeeTextField.vue'
import BeeTreeview from './components/custom-components/mirta-based/BeeTreeview'
import BeeWeather from "./components/custom-components/toolkits/readonly/BeeWeather/BeeWeather.vue";
import BeeMaterialAutocomplete from "./components/custom-components/mirta-based/BeeMaterialAutocomplete";
import BeeMaterialAmountLabel from "./components/custom-components/mirta-based/BeeMaterialAmountLabel.vue"
import i18n from './i18n/i18n.js'

import BeeComponents from '@beetronix/bee-components'
import Tooltip from './components/Tooltip'
// import { decode } from 'js-base64'
Vue.use(BeeComponents);
Vue.component('Tooltip', Tooltip)
import VueApexCharts from 'vue-apexcharts'
// custom-components
Vue.component("bee-autocomplete", BeeAutocomplete)
Vue.component("bee-accounting-no-field", BeeAccountingNoField)
Vue.component("bee-account-autocomplete", BeeAccountAutocomplete)
Vue.component("bee-account-label", BeeAccountLabel)
Vue.component("bee-advanced-money-label", BeeAdvancedMoneyLabel)
Vue.component("bee-btn", BeeBtn)
Vue.component("bee-breadcrumbs", BeeBreadcrumbs)
Vue.component("bee-bond-up-down", BeeBondUpDown)
Vue.component("bee-progress-circular", BeeProgressCircular)
Vue.component("bee-progress-linear", BeeProgressLinear)
Vue.component("bee-checkbox", BeeCheckbox)
Vue.component("bee-currencies-autocomplete", BeeCurrenciesAutocomplete)
Vue.component("bee-combobox", BeeCombobox)
Vue.component("bee-confirm-dialog", BeeConfirmDialog)
Vue.component("bee-date-field", BeeDateField)
Vue.component("bee-date-picker", BeeDatePicker)
Vue.component("bee-datatable", BeeDatatable)
Vue.component("bee-data-iterator", BeeDataIterator)
Vue.component("bee-dialog", BeeDialog)
Vue.component('bee-date-label', BeeDateLabel)
Vue.component("bee-label", BeeLabel)
Vue.component("bee-list", BeeList)
Vue.component("bee-list-item", BeeListItem)
Vue.component("bee-list-group", BeeListGroup)
Vue.component("bee-multi-select", BeeMultiSelect)
Vue.component("bee-money-field", BeeMoneyField)
Vue.component("bee-money-label", BeeMoneyLabel)
Vue.component("bee-numeric-field", BeeNumericField)
Vue.component("bee-outlined-header-info", BeeOutlinedHeaderInfo)
Vue.component("bee-quantity-label", BeeQuantityLabel)
Vue.component("bee-simple-table", BeeSimpleTable)
Vue.component("bee-smart-table", BeeSmartTable)
Vue.component("bee-snackbar", BeeSnackbar);
Vue.component("bee-table-row", BeeTableRow)
Vue.component("bee-table-header", BeeTableHeader)
Vue.component("bee-text-field", BeeTextField)
Vue.component("bee-treeview", BeeTreeview)
Vue.component("bee-weather", BeeWeather)
Vue.component("bee-hint-menu", BeeHintMenu)
Vue.component("bee-material-autocomplete", BeeMaterialAutocomplete)
Vue.component("bee-material-amount-label", BeeMaterialAmountLabel)
Vue.component('apexchart', VueApexCharts)
Vue.use(VueApexCharts)
// features-components
Vue.component("splash-window", splashWindow)

//Global axios
window.axios= axios.create({
    // baseURL:'https://mirta-api.beetronix.com/api/', //local test
    // baseURL:'https://mirta-api-mirror.beetronix.com/api/', //local test mirror
    //baseURL:'http://localhost:8662/api/', //local Yaman
    // baseURL:'http://beeserver:94/api'
    // baseURL: 'https://mirta-api.beetronix.com/api/'
    // baseURL: 'http://beeserver:98/api/'
    // baseURL: 'https://emerald-core-api.beetronix.com/api/'
    baseURL: 'https://emeraldmirror-api.mirta.net/api/'
    // baseURL: 'https://alradwan-accounting-api.beetronix.com/api/'
})
EventBus.$on('financial-file-id-changed', ()=>{ window.axios.defaults.headers['X-FinancialFileId'] = ls.getLocalFinancialFileId();});
window.axios.defaults.headers['X-FinancialFileId'] = ls.getLocalFinancialFileId();

window.axios.interceptors.response.use(
    (response) => {
        // Synchronize(response.headers)
        return response;
    },

    error => {
        if (
            error &&
            error.response &&
            error.response.status === 401 &&
            store.getters["auth/isAuthenticated"]
        )
            store.dispatch("auth/logout");

        if (error) {
            EventBus.$emit("error", getDetailedError(error));
        }

        return Promise.reject(error);
    }
)

if ("auth" in localStorage) {
    try {
        const auth = JSON.parse(localStorage.getItem("auth"));   
        // let authHeader = `Basic ${window.btoa(`${auth.username}:${decode(auth.password)}`)}`;
        const authHeader = `Bearer ${auth.token}`;
        // if (auth.authenticated) {
        window.axios.defaults.headers.common.Authorization = authHeader;
        
        store.commit("auth/LOGIN", auth);
        // } else {
            // localStorage.removeItem("auth");
            // }
        } catch (e) {
            localStorage.removeItem("auth");
            router.replace({ name: 'login' })
        }
}

router.beforeEach((to, from, next) => {
	if (to.name != 'login' && !store.getters['auth/isAuthenticated'])
		next({name: 'login', replace: true});
	else {
        if (
            !ls.getLocalFinancialFileId() &&
            !['login','quick-financial-file-selector', 'financial-files', 'users'].includes(to.name) &&
            (!to.name.includes('statistics') &&  !to.name.includes('currencies'))
        )
            next({name: 'quick-financial-file-selector', replace: true});
        else
		    next();
    }
});

Vue.mixin({
    methods: {
        initializeMainDivTop: function (){
            EventBus.$emit('assign-dynamic-width') 
            if(document.getElementById('main'))
                document.getElementById('main').style.top = document.getElementById("tool-bar").offsetHeight + 'px'
        },
    },
})
window.observer = new ResizeObserver(entries => {  
    
    for (const entry of entries) {
        if(entry.target.id == 'tool-bar')
        {
            if(document.getElementById('main'))
                document.getElementById('main').style.top = document.getElementById("tool-bar").offsetHeight + 'px'
        }
        if(entry.target.id == 'footer')
        {
            let footerHeight = document.getElementById("footer").offsetHeight
            
            if(document.getElementById('main'))
                document.getElementById('main').style.paddingBottom = footerHeight + 40 + 'px'
        }   
    }
})
// if (i18n.locale === 'ar') {
//     require('@/scss/rtl.scss');
// }
// if (i18n.locale != 'ar') {
//     require('@/scss/ltr.scss');
// }

const emeraldPlugin = {
    install: (Vue) => {
        Vue.prototype.$emerald = {
            ifLang: (lang, trueValue, falseValue) => {
                if (Array.isArray(lang)) {
                    if (lang.includes(i18n.locale)) {
                        if (Array.isArray(trueValue)) {
                            return trueValue[lang.indexOf(i18n.locale)]
                        }
                        else {
                            return trueValue;
                        }
                    }
                    else {
                        return falseValue;
                    }
                }
                else {
                    if (i18n.locale === lang) {
                        return trueValue
                    }
                    else {
                        return falseValue
                    }
                }
            }
        }
    }
}
Vue.use(emeraldPlugin);

new Vue({
    vuetify,
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')

PaceProgress.options.ajax.trackMethods = ['GET', 'POST', 'DELETE', 'PUT', 'PATCH']
PaceProgress.start();